export default __webpack_public_path__ + "static/media/card-back.afa257a6.png";